/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeBulkMoveDocumentsRequest, type BulkMoveDocumentsRequest, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/companydocs/documents/bulk-move
 */
export interface BulkMoveRequestBuilder extends BaseRequestBuilder<BulkMoveRequestBuilder> {
    /**
     * Files up to 100 documents under the same folder in one call. Send at least one id and no more than 100; send targetFolderId as null to move them all to the top level. The documents are moved one at a time and this is not a transaction: if the call fails part-way the moves already applied stay applied, and because moving is repeatable the fix is to send the same request again. Ids that no longer exist are skipped, and an unknown targetFolderId is accepted as given — take it from the folders endpoints. Nothing is returned on success.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: BulkMoveDocumentsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Files up to 100 documents under the same folder in one call. Send at least one id and no more than 100; send targetFolderId as null to move them all to the top level. The documents are moved one at a time and this is not a transaction: if the call fails part-way the moves already applied stay applied, and because moving is repeatable the fix is to send the same request again. Ids that no longer exist are skipped, and an unknown targetFolderId is accepted as given — take it from the folders endpoints. Nothing is returned on success.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: BulkMoveDocumentsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const BulkMoveRequestBuilderUriTemplate = "{+baseurl}/api/companydocs/documents/bulk-move";
/**
 * Metadata for all the requests in the request builder.
 */
export const BulkMoveRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: BulkMoveRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeBulkMoveDocumentsRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
